<div align="center">
  <mat-form-field class="filtro-tabla">
    <mat-label>Filtrar informes</mat-label>
    <input
      matInput
      (keyup)="applyFilter($event)"
      placeholder="Buscar informe..."
    />
  </mat-form-field>
</div>

<div
  class="mat-elevation-z8"
  style="width: 95%; margin-left: 1vw"
  align="center"
  [hidden]="loading"
>
  <table
    mat-table
    [dataSource]="dataSource"
    matSort
    (matSortChange)="sortData($event)"
    class="mat-elevation-z8"
  >
    <ng-container
      matColumnDef="uuid_informe"
      *ngIf="user.rol.includes('admin')"
    >
      <th mat-header-cell *matHeaderCellDef><b>uuid del informe</b></th>
      <td
        mat-cell
        *matCellDef="let d"
        ngxClipboard
        [cbContent]="d.uuid"
        (cbOnSuccess)="copiado($event)"
      >
        {{ d.uuid }}
      </td>
    </ng-container>

    <ng-container matColumnDef="titulo_informe">
      <th mat-header-cell *matHeaderCellDef><b>Título del informe</b></th>
      <td mat-cell *matCellDef="let d">
        {{ d.titulo }}
      </td>
    </ng-container>

    <ng-container matColumnDef="fabrica">
      <th mat-header-cell *matHeaderCellDef><b>Fábrica</b></th>
      <td mat-cell *matCellDef="let d">
        <ul
          *ngFor="let references of d.referenceConnection.edges; let i = index"
        >
          <li style="list-style-type: disc">{{ references.node.nombre }}</li>
        </ul>
      </td>
    </ng-container>

    <ng-container matColumnDef="logo_informe">
      <th mat-header-cell *matHeaderCellDef><b>Logo del informe</b></th>
      <td mat-cell *matCellDef="let d">
        <ng-container
          *ngIf="!d.logo || d.logo === null || d.logo == ''; else logoTemplate"
        >
          {{ "GENERIC.NO_LOGO" | translate }}
        </ng-container>
        <ng-template #logoTemplate>
          <img
            #image
            [src]="d.logo"
            onerror="this.src='assets/images/error-logo.png'; style='width:45px'; title = 'Error al cargar la imagen desde el servidor'"
            width="100px"
          />
        </ng-template>
      </td>
    </ng-container>

    <ng-container matColumnDef="generar_informe">
      <th mat-header-cell *matHeaderCellDef><b>Generar informe</b></th>
      <td mat-cell *matCellDef="let d; let i = index">
        <a
          mat-button
          color="primary"
          (click)="generateReport(d)"
          href="{{ pdfString }}"
          target="_blank"
        >
          <mat-icon>vertical_align_bottom</mat-icon>
        </a>
      </td>
    </ng-container>

    <ng-container
      matColumnDef="acciones_informe"
      *ngIf="user.rol.includes('admin')"
    >
      <th mat-header-cell *matHeaderCellDef><b>Acciones de informe</b></th>
      <td mat-cell *matCellDef="let d; let i = index">
        <button
          mat-button
          color="primary"
          [routerLink]="[d.link, 'edit', d.uuid]"
        >
          <mat-icon>create</mat-icon>
        </button>
        <button mat-button color="warn" (click)="borrar(d)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <mat-paginator
    [pageSizeOptions]="[5, 10, 25]"
    showFirstLastButtons
    [hidden]="loading"
  ></mat-paginator>
</div>

<hr style="margin-left: 2vw; margin-top: 35px; width: 85%" />
